<template>
  <v-container>
    <v-row align="center">
      <v-col class="pr-0" cols="5">
        <h4>MethylationEPIC</h4>
        <v-radio-group v-model="MethylationEPIC">
          <v-radio
            v-for="(item, index) in epic_radio"
            color="primary"
            :key="index"
            :label="item.text"
            :value="item.value"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-col class="py-0 pr-0" cols="7">
        <iframe
          id="imageBrain"
          title="imageBrain"
          frameborder="0"
          scrolling="no"
          width="600"
          height="400"
          src="/nilearn_plot_ostz2cjc.html"
        >
        </iframe>
      </v-col>
    </v-row>
    <v-tabs
      v-model="tab"
      color="primary"
      active-class="font-weight-bold black--text"
    >
      <v-tab
        style="text-transform: none"
        v-for="item in items"
        :key="item.tab"
        @click="clearTabInfo()"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in items" :key="item.tab">
        <v-card flat>
          <div class="grey lighten-3 mb-8">
            <v-card-text>
              {{ item.content }}
            </v-card-text>
            <v-row align="center">
              <v-col cols="1" class="ml-5 pr-0">
                <h5>{{ item.label }}</h5>
              </v-col>
              <v-col cols="3" class="pl-0">
                <v-text-field
                  v-model="inputCpgGene"
                  hide-details
                  filled
                  dense
                  @keydown.enter.prevent="submit()"
                ></v-text-field>
              </v-col>

              <v-btn
                small
                outlined
                depressed
                class="my-5"
                color="grey darken-3"
                :disabled="isProcessing"
                @click="submit()"
              >
                {{ submitBtn }}
              </v-btn>
            </v-row>
            <v-row>
              <v-btn
                small
                v-if="show_methy_table == true"
                class="ml-8 my-2"
                @click="downloadCSV()"
                color="primary"
              >
                Download Result File
              </v-btn>
            </v-row>
            <div v-if="show_methy_table == true" class="ma-3">
              {{ methy_data_len }} Result(s) Found
            </div>
            <v-data-table
              v-if="show_methy_table == true"
              class="grey lighten-3 ma-2"
              :headers="result_header"
              :items="methy_data"
              :items-per-page="-1"
              hide-default-footer
              dense
            >
              <template v-slot:methy_data="dataRow">
                <td>{{ dataRow[methy_column.value] }}</td>
              </template>
            </v-data-table>
            <v-alert
              v-if="error_msg == true"
              class="ma-3"
              text
              dense
              outlined
              type="error"
            >
              No records found
            </v-alert>
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
<script>
import { getFunctions, httpsCallable } from 'firebase/functions'
import {
  epicRadio,
  constantHeader,
  methyColumn,
  flagKey
} from './SearchFormVariable'

export default {
  name: 'SearchForm',
  data () {
    return {
      MethylationEPIC: null,
      tab: 0,
      inputCpgGene: null,
      epic_radio: epicRadio,
      constant_header: constantHeader,
      methy_column: methyColumn,
      items: [
        {
          tab: 'By CpG',
          label: 'CpG :',
          content:
            '"By CpG" provides summary statistics, including average methylation, standard deviation, and Spearman’s rank correlation coefficients (rho), and p-values for each pair of tissues for input CpG site name across 19 samples and four tissues (brain, blood, saliva and buccal).'
        },
        {
          tab: 'By Gene',
          label: 'Gene :',
          content:
            '"By Gene" provides summary statistics, including average methylation, standard deviation, and Spearman’s rank correlation coefficients (rho), and p-values for each pair of tissues for each CpG site within the input gene across 19 samples and four tissues (brain, blood, saliva and buccal).'
        }
      ],
      result_header: null,
      selected_header: null,
      show_methy_table: false,
      methy_data_len: null,
      methy_data: [],
      error_msg: false,
      res: null,
      res_data: [],
      submitBtn: 'submit',
      isProcessing: false,
      flag_key: flagKey
    }
  },
  methods: {
    // tab切り替え時にclearする
    clearTabInfo () {
      this.inputCpgGene = null
      this.methy_data_len = null
      this.show_methy_table = false
      this.methy_data = []
      this.error_msg = false
    },
    async submit () {
      this.isProcessing = true
      this.submitBtn = 'Working...'
      if (this.MethylationEPIC && this.inputCpgGene) {
        try {
          const functions = getFunctions()
          let res = null
          if (this.tab === 0) {
            res = await httpsCallable(
              functions,
              'selectCpgData'
            )(this.inputCpgGene)
          } else {
            res = await httpsCallable(
              functions,
              'selectGeneData'
            )(this.inputCpgGene)
          }
          this.res_data = res.data
          if (res.data.length > 0) {
            this.res_data = res.data.map((obj) => this.transformBool(obj))
            const displayData = this.res_data.map((obj) => this.transform(obj))
            this.methy_data = displayData

            this.result_header = []
            this.methy_data_len = this.methy_data.length
            let selectedCategory = []
            if (this.MethylationEPIC === 'Brain-Blood') {
              selectedCategory = ['Brain', 'Blood', 'Brain-Blood', 'Brain-Blood-Saliva-Buccal']
            } else if (this.MethylationEPIC === 'Brain-Saliva') {
              selectedCategory = ['Brain', 'Saliva', 'Brain-Saliva', 'Brain-Blood-Saliva-Buccal']
            } else if (this.MethylationEPIC === 'Brain-Buccal') {
              selectedCategory = ['Brain', 'Buccal', 'Brain-Buccal', 'Brain-Blood-Saliva-Buccal']
            } else if (this.MethylationEPIC === 'Blood-Saliva') {
              selectedCategory = ['Blood', 'Saliva', 'Blood-Saliva', 'Brain-Blood-Saliva-Buccal']
            } else if (this.MethylationEPIC === 'Blood-Buccal') {
              selectedCategory = ['Blood', 'Buccal', 'Blood-Buccal', 'Brain-Blood-Saliva-Buccal']
            } else if (this.MethylationEPIC === 'Saliva-Buccal') {
              selectedCategory = ['Saliva', 'Buccal', 'Saliva-Buccal', 'Brain-Blood-Saliva-Buccal']
            } else if (this.MethylationEPIC === 'Brain-Blood-Saliva-Buccal') {
              selectedCategory = [
                'Brain',
                'Blood',
                'Saliva',
                'Buccal',
                'Brain-Blood',
                'Brain-Saliva',
                'Brain-Buccal',
                'Brain-Blood-Saliva-Buccal'
              ]
            }
            this.selected_header = this.extractHeader(selectedCategory)
            this.createHeader()
            this.isProcessing = false
            this.submitBtn = 'submit'
            this.show_methy_table = true
            this.error_msg = false
          } else {
            this.showErrorMessage()
          }
        } catch (e) {
          console.log(e)
          this.showErrorMessage()
        }
      } else {
        this.showErrorMessage()
      }
    },
    extractHeader (selectedCategory) {
      return this.methy_column.filter((array) => selectedCategory.includes(array.category))
    },
    showErrorMessage () {
      this.isProcessing = false
      this.submitBtn = 'submit'
      this.show_methy_table = false
      this.error_msg = true
    },
    createHeader () {
      this.result_header.push(...this.constant_header)
      this.result_header.push(...this.selected_header)
    },
    // booleanを1→TRUE、0→FALSEに変換する
    transformBool (obj) {
      const formatedObj = {}
      for (const [key, value] of Object.entries(obj)) {
        if (this.flag_key.includes(key)) {
          formatedObj[key] = value ? 'TRUE' : 'FALSE'
        } else {
          formatedObj[key] = value
        }
      }
      return formatedObj
    },
    // 数値データのみ表示形式を編集する
    transform (obj) {
      // 数値データ以外のキー
      const ignoreKey = [
        'cgid', 'chr', 'MAPINFO', 'Gene_Name',
        '#clusters_BL', 'SNP_BL', '#clusters_SA', 'SNP_SA', '#clusters_EP', 'SNP_EP'
      ]
      ignoreKey.push(...this.flag_key)
      const formatedObj = {}

      for (const [key, value] of Object.entries(obj)) {
        if (ignoreKey.includes(key)) {
          formatedObj[key] = value
        } else {
          const truncNum = Math.trunc(parseFloat(value) * 100) / 100
          formatedObj[key] = truncNum.toFixed(2)
        }
      }

      return formatedObj
    },
    downloadCSV () {
      const csvHeader = this.result_header.map(item => item.value)
      csvHeader.splice(3, 0, 'Gene_Name')
      this.onDownload(csvHeader)
    },
    onDownload (header) {
      const item = this.res_data.map((obj) => {
        const formatedObj = []
        if (obj.Gene_Name === null || obj.Gene_Name === '') {
          obj.Gene_Name = 'NA'
        }

        for (const [key, value] of Object.entries(obj)) {
          if (header.includes(key)) {
            formatedObj.push(value)
          } else {
            delete formatedObj[key]
          }
        }
        return formatedObj
      })

      item.unshift(header)
      const csv = item.join('\r\n')
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      const blob = new Blob([bom, csv], { type: 'text/csv' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'methyl_data.csv'
      link.click()
    }
  }
}
</script>

<style>
.v-data-table table {
  border: 1px #bdbdbd solid; /* 枠：grey lighten-1*/
}
.v-data-table th {
  white-space: nowrap; /* 改行禁止*/
}
/* 行の色を変更 */
.v-data-table td {
  background: #eeeeee; /* 偶数行：grey lighten-3*/
}
.v-data-table tr:nth-child(odd) td {
  background: #fafafa; /* 奇数行：grey lighten-5*/
}
</style>
